import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { Filter } from "../../models/filter.model";
import { NLOffer } from "../../models/nl-models/nl-offer.model";

@Injectable()
export class NLOfferService {

    constructor(
        private httpClient: HttpClient
    ) { }


    adminView(filter: Filter) {
        return this.httpClient.post('api/nloffers/adminview', filter.data)
            .pipe(
                map((res: any) => {
                    return res;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

    gridView(filter: Filter) {
        return this.httpClient.post('api/nloffers/gridview', filter.data)
            .pipe(
                map((res: any) => {
                    return res;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

    createOffer(offer: NLOffer) {
        return this.httpClient.post('api/nloffers/create', offer).toPromise()
    }

    changeStatus(offerStatus: number, offerID: number) {
        return this.httpClient.post('api/nloffers/changestatus', { NewOfferStatus: offerStatus, OfferID: offerID }).toPromise()
    }

    offerReport(filter: Filter) {
        return this.httpClient.post('api/reports/komdom/offers', filter.data)
            .pipe(
                map((res: any) => {
                    return res;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

    offerExportReport(filter: Filter) {
        return this.httpClient.post('api/reports/komdom/offers/excel', filter, { observe: 'response', responseType: 'blob' }).toPromise()
    }

    offerGroupReport(filter: Filter, reportType: number, groupBy: number) {
        return this.httpClient.post('api/reports/komdom/cc', { Filter: filter.data.Filter, ReportType: reportType, GroupBy: groupBy })
            .pipe(
                map((res: any) => {
                    return res;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

    offerGroupExportReport(filter: Filter, reportType: number, groupBy: number) {
        return this.httpClient.post('api/reports/komdom/cc/excel', { Filter: filter.data.Filter, ReportType: reportType, GroupBy: groupBy }, { observe: 'response', responseType: 'blob' }).toPromise()
    }

    uploadDocuments(files: FormData) {
        return this.httpClient.post('api/nloffers/useruploaddocuments', files).toPromise()
    }

    downloadDocuments(id: number) {
        return this.httpClient.get('api/nloffers/downloaddocuments/' + id, { observe: 'response', responseType: 'blob' }).toPromise()
    }

    offersExcel(filter: Filter) {
        return this.httpClient.post('api/nloffers/excel', filter.data.Filter, { observe: 'response', responseType: 'blob' });
    }

    changeMailReceived(change: { id: number, mailReceived: boolean }) {
        return this.httpClient.patch('api/nloffers/editmailreceived', change).toPromise()
    }

}